import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'shabic-icon-verify-checkmark-invert',
  templateUrl: './icon-verify-checkmark-invert.component.html',
  styleUrls: ['./icon-verify-checkmark-invert.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconVerifyCheckmarkInvertComponent {}
